import { appEvents } from '@/store/app.events';

/**
 * Dashboard Tour Step Definitions.
 * Declarative, engine-agnostic configuration for the Dashboard onboarding guide.
 */
export const dashboardTourConfig = {
  id: 'dashboard-onboarding',
  storageKey: 'triad_tour_dashboard_completed',
  steps: [
    {
      id: 'quick-search',
      target: () => {
        const searchInput = document.querySelector('[data-tour="search-playlists"]');
        if (searchInput && (searchInput.offsetWidth > 0 || searchInput.getClientRects().length > 0)) {
          return searchInput;
        }
        const quickSearch = document.querySelector('[data-tour="quick-search"]');
        if (quickSearch && (quickSearch.offsetWidth > 0 || quickSearch.getClientRects().length > 0)) {
          const container = quickSearch.closest('.menu-container');
          if (!container || container.offsetWidth > 0) {
            return quickSearch;
          }
        }
        return null;
      },
      titleKey: 'tour.dashboard.searchTitle',
      descriptionKey: 'tour.dashboard.searchDesc',
      position: 'bottom',
      align: 'start',
      scrollIntoView: true,
      allowMissing: true
    },
    {
      id: 'create-playlist',
      target: () => {
        const createBtn = document.querySelector('[data-tour="create-playlist"]');
        if (createBtn && (createBtn.offsetWidth > 0 || createBtn.getClientRects().length > 0)) {
          return createBtn;
        }
        const emptyBtn = document.querySelector('[data-tour="empty-create-playlist"]');
        if (emptyBtn && (emptyBtn.offsetWidth > 0 || emptyBtn.getClientRects().length > 0)) {
          return emptyBtn;
        }
        return null;
      },
      titleKey: 'tour.dashboard.createTitle',
      descriptionKey: 'tour.dashboard.createDesc',
      position: 'bottom',
      align: 'end',
      scrollIntoView: true,
      allowMissing: true
    },
    {
      id: 'highlighted-playlist',
      target: '[data-tour="highlighted-playlist"]',
      titleKey: 'tour.dashboard.highlightTitle',
      descriptionKey: 'tour.dashboard.highlightDesc',
      position: 'bottom',
      align: 'start',
      scrollIntoView: true,
      allowMissing: true // Not present if user has no playlists yet
    },
    {
      id: 'navigation-menu',
      target: '[data-tour="side-menu-navigation"]',
      titleKey: 'tour.dashboard.menuTitle',
      descriptionKey: 'tour.dashboard.menuDesc',
      position: 'right',
      align: 'start',
      openMenu: () => appEvents.emit('sidemenu:open'),
      closeMenu: () => appEvents.emit('sidemenu:close'),
      scrollIntoView: true
    },
    {
      id: 'downloaded-hub',
      target: () => document.querySelector('[data-tour="downloaded-hub"]'),
      titleKey: 'tour.dashboard.downloadedTitle',
      descriptionKey: 'tour.dashboard.downloadedDesc',
      position: 'right',
      align: 'start',
      openMenu: () => {
        if (typeof window !== 'undefined' && window.innerWidth < 768) {
          appEvents.emit('sidemenu:open');
        } else {
          appEvents.emit('sidemenu:close');
        }
      },
      closeMenu: () => appEvents.emit('sidemenu:close'),
      scrollIntoView: true,
      allowMissing: true
    }
  ]
};

export default dashboardTourConfig;
